import { cyrb53 } from '../../core/hash';
import type { Lot } from './types';

type Placed = Pick<Lot, 'kind' | 'sourceId' | 'side' | 'ordinal'>;

/**
 * A lot's name: its kind, its source, the side and its place along it. Every random choice about
 * a lot and its house forks on this name, so a change to one source moves only the lots on it
 * and on the sources whose ground they take, never the rest of the city.
 */
export function lotKey(lot: Placed): string {
  return `${lot.kind}:${lot.sourceId}:${lot.side}:${lot.ordinal}`;
}

/**
 * The number a house's linework object ID is taken from. It runs on along each side of a source
 * from a start named after that side, so it too is the same wherever other sources change, and
 * neighbouring houses along a street never share one.
 */
export function lotEdgeIndex(lot: Placed): number {
  return (cyrb53(`${lot.kind}:${lot.sourceId}:${lot.side}`) >>> 0) + lot.ordinal;
}
